import { useEffect, useRef } from 'react';
import { isSearchableQuery, SearchState, SEARCH_DEBOUNCE_MS } from '../../../../lib/search';
import { useGenericBi } from '../../../../lib/use-generic-bi';

// Sidebar search BI — debounced search_conversations mirrors mobile's 250ms
// commit; search_no_results fires once per empty result set.
export function useMenuSearchBi(query: string, searchState: SearchState) {
  const { logPageClickBi } = useGenericBi();
  const lastSearchRef = useRef<string | null>(null);
  const lastNoResultsRef = useRef<string | null>(null);

  useEffect(() => {
    const trimmed = query.trim();
    // Below the minimum length nothing is searched, so nothing is logged as a search either.
    if (!isSearchableQuery(trimmed)) {
      lastSearchRef.current = null;
      lastNoResultsRef.current = null;
      return;
    }
    const timer = setTimeout(() => {
      if (lastSearchRef.current === trimmed) return;
      lastSearchRef.current = trimmed;
      logPageClickBi({
        page_name: 'menu',
        button_name: 'search_conversations',
        origin: 'menu',
        state: String(trimmed.length),
      });
    }, SEARCH_DEBOUNCE_MS);
    return () => clearTimeout(timer);
  }, [query]);

  useEffect(() => {
    const trimmed = query.trim();
    if (!trimmed || searchState.kind !== 'ready' || searchState.results.length > 0) return;
    if (searchState.query !== trimmed) return;
    if (lastNoResultsRef.current === trimmed) return;
    lastNoResultsRef.current = trimmed;
    logPageClickBi({
      page_name: 'menu',
      button_name: 'search_no_results',
      origin: 'menu',
      state: String(trimmed.length),
    });
  }, [query, searchState]);
}
